import { AddressViewModel } from '@bhtp-client-web/component';

export class Address extends AddressViewModel { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/address.model.ts